fragment TeamFragment on Group {
  id
  kind
  isHidden
  name
  type
  parentIds
  hierarchyIds
  attributes {
    id
    attributeType
    subtype
    label
    value
  }
}


fragment GroupPermissionsFragment on GroupPermissions {
  areGroupsInAccessGroupIdsHierarchy
  updateGroupAttributes
}





fragment accessGroupsFragment on Group {
  id
  name
  type
  parentIds
  hierarchy
  hierarchyIds
  attributes {
    id
    attributeType
    subtype
    label
    value
  }
  permissions {
    ...GroupPermissionsFragment
  }
}



fragment PersonFragmentForTaggedMembersPanel on Person {
  aggregateId
  employeeId
  avatar
  company
  fte
  jobTitle
  firstName
  surname
  preferredName
  memberOf {
    id
    parentIds
    name
    type
    hierarchy
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
  }
  tags: appliedTags(filter: $tagFilter) {
    id
    tagId
    type
    displayValue
    isActive
    attributes
    entityTagAttributes
  }
}

fragment PersonFragment on Person {
  address
  country
  city
  aggregateId
  employeeId
  allocations {
    fte
    targetGroupId
  }
  attributes {
    attributeType
    subtype
    value
    id
  }
  avatar
  userAvatarOriginal
  userAvatarCropped
  userAvatarCropData {
    x
    y
    width
    height
  }
  bands
  company
  fte
  jobTitle
  firstName
  surname
  preferredName
  span
  division {
    id
    name
    hierarchy
  }
  managing {
    aggregateId
  }
  memberOf {
    id
    parentIds
    name
    type
    hierarchy
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
    permissions {
      ...GroupPermissionsFragment
    }
    tags {
      id
      type
      displayValue
      isActive
      attributes
    }
  }
  accessGroups {
    ...accessGroupsFragment
  }
  tags: appliedTags {
    id
    tagId
    type
    displayValue
    isActive
    attributes
    entityTagAttributes
  }
  sourceGroupIds
  permissions {
    isInAccessGroupIdsHierarchy
  }
}

fragment PersonBaseFragment on Person {
  address
  country
  city
  aggregateId
  employeeId
  avatar
  bands
  company
  fte
  jobTitle
  firstName
  surname
  preferredName
}

fragment GlobalSearchPersonBaseFragment on Person {
  ...PersonBaseFragment
  allocations {
    fte
    targetGroupId
  }
  attributes {
    attributeType
    subtype
    value
  }
  division {
    id
    name
    hierarchy
  }
  memberOf {
    id
    parentIds
    name
    type
    hierarchy
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
  }
  sourceGroupIds
}


# Minimal variant for allocation search - avoids managedByHierarchy.avatar/jobTitle
fragment PersonManagersTagsMinimalFragment on Person {
  managedBy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
    attributes {
      attributeType
      subtype
      value
    }
  }
  managedByHierarchy {
    firstName
    surname
    preferredName
    aggregateId
  }
  tags: appliedTags {
    displayValue
    id
    isActive
    tagId
    type
  }
}

fragment PersonManagersTagsFragment on Person {
  managedBy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
    attributes {
      attributeType
      subtype
      value
    }
  }
  managedByHierarchy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
  }
  tags: appliedTags {
    displayValue
    id
    isActive
    tagId
    type
  }
}



fragment GroupFragment on Group {
  id
  name
  kind
  type
  hierarchy
  hierarchyIds
  parentIds
  objectiveIds
  isHidden
  attributes {
    id
    attributeType
    subtype
    label
    value
  }
  childTeams {
    ...TeamFragment
  }
  members(limit: 500) {
    ...PersonFragment
    ...PersonManagersTagsFragment
  }
  permissions {
    ...GroupPermissionsFragment
  }
}

# Used for useSearchGroups hook
fragment GroupBaseFragment on Group {
  id
  name
  kind
  type
  isHidden
  parentIds
  hierarchy
  hierarchyIds
}




fragment TeamDetailBaseFragment on Group {
  id
  name
  kind
  type
  hierarchyIds
  parentIds
  objectiveIds
  isHidden
  isDeleted
  attributes {
    id
    attributeType
    subtype
    label
    value
  }
  permissions {
    ...GroupPermissionsFragment
  }
}

fragment TeamDetailFragment on Group {
  ...TeamDetailBaseFragment
  hierarchy
  forecastSubmittedAt
  forecastSubmittedFor
  propertyOverrides {
    directParent {
      previousDirectParentId
    }
  }
}

fragment TeamMemberCountFragment on Group {
  id
  memberCount
  directMemberCount
}


fragment TeamBudgetsFragment on Group {
  budgets {
    allocationProjectId
    targetGroupId
    value
  }
  dailyRate
}



fragment ObjectiveFragment on Group {
  id
  name
  kind
  type
  attributes {
    value
    attributeType
  }
  parentObjectiveIds
  parentObjectives {
    id
    name
    type
    attributes {
      value
      attributeType
    }
    datasource {
      id
      type
    }
  }
  datasource {
    id
    type
  }
}


fragment baseChildGroupFragment on Group {
  id
  name
  type
  isHidden
  hierarchyIds
  parentIds
  attributes {
    id
    attributeType
    subtype
    label
    value
  }
}

fragment childGroupFragment on Group {
  ...baseChildGroupFragment
}


fragment PersonCardFragmentNoSourceGroupIds on Person {
  aggregateId
  employeeId
  firstName
  surname
  preferredName
  jobTitle
  company
  fte
  bands
  avatar
  attributes {
    attributeType
    subtype
    value
  }
  tags: appliedTags {
    id
    tagId
    type
    displayValue
    isActive
    attributes
    entityTagAttributes
  }
  permissions {
    isInAccessGroupIdsHierarchy
  }
  allocations {
    fte
    targetGroupId
  }
  memberOf {
    id
    name
    type
    hierarchy
    hierarchyIds
  }
}

fragment PersonCardFragment on Person {
  ...PersonCardFragmentNoSourceGroupIds
  sourceGroupIds
}


fragment PersonManagerFragment on Person {
  managedBy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
    attributes {
      attributeType
      subtype
      value
    }
  }
}




# Minimal variant for search/display - no tagTypeName, avoids payload bloat
fragment TagMinimalFragment on Tag {
  id
  type
  displayValue
  isActive
  attributes
  appliedCount
  tagAttributesMetaData {
    person {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
  }
}

# Use TagFragmentWithAppliedCount instead
fragment TagFragment on Tag {
  id
  type
  displayValue
  isActive
  attributes
  appliedCount
  tagTypeName
  tagAttributesMetaData {
    person {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
  }
}

fragment TagFragmentWithAppliedCount on Tag {
  id
  type
  displayValue
  isActive
  attributes
  appliedCount @include(if: $showAppliedCount)
  tagTypeName
  tagAttributesMetaData {
    person {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
    people @include(if: $showTagOwners) {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
  }
}

fragment TagPropertyFragment on TagProperty {
  id
  label
  value
  attributeType
  subtype
}

# Minimal fragment for allocation/caching - avoids tagAttributesMetaData payload
fragment EntityTagMinimalFragment on EntityTag {
  id
  tagId
  type
  replace
  entityId
  entityTagAttributes
  status
  tag {
    id
    displayValue
    type
    attributes
    isActive
  }
}

fragment EntityTagFragment on EntityTag {
  id
  tagId
  type
  replace
  entityId
  entityTagAttributes
  status
  tag {
    id
    displayValue
    type
    attributes
    appliedCount
    isActive
    tagAttributesMetaData {
      person {
        aggregateId
        preferredName
        firstName
        surname
        avatar
      }
    }
  }
}



fragment TagsEditorEntityTagFragment on EntityTag {
  id
  tagId
  type
  replace
  entityId
  entityTagAttributes
  status
  entityType
  tag {
    id
    displayValue
    type
    attributes
    appliedCount @include(if: $includeAppliedCount)
    isActive
    tagAttributesMetaData {
      person {
        aggregateId
        preferredName
        firstName
        surname
        avatar
      }
    }
  }
}



query getGroupQuery($groupId: String!) {
  getGroup(groupId: $groupId) {
    ...GroupFragment
    groupAssociations {
      tag {
        id
        tagTypeMetadata {
          name
        }
        type
        displayValue
      }
      group {
        ...GroupFragment
      }
      associationDirection {
        mode
        description
      }
    }
  }
}

query getTeamDetailsQuery($groupId: String!) {
  getGroup(groupId: $groupId) {
    ...TeamDetailFragment
    tags {
      id
      type
      displayValue
      isActive
      attributes
      tagAttributesMetaData {
        person {
          aggregateId
          preferredName
          firstName
          surname
          avatar
        }
      }
    }
  }
}

query getTeamMembersQuery($groupId: String!) {
  team: getGroup(groupId: $groupId) {
    id
    members(limit: 500) {
      ...PersonCardFragment
      ...PersonManagerFragment
      isPlaceholder
      isVacancy
      span
    }
  }
}

query getTeamAndMembersAndChildTeamsQuery(
  $groupId: String!
  $includeMembers: Boolean = true
  $membersLimit: Int = 500
  $membersOffset: Int = 0
  $includeTeams: Boolean = true
  $teamsLimit: Int = 500
  $teamsOffset: Int = 0
) {
  team: getGroup(groupId: $groupId) {
    id
    name
    kind
    type
    isHidden
    isDeleted
    directParentId
    hierarchyIds # needed for move group modal
    memberCount
    directMemberCount
    childTeamCount
    directChildTeamCount
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
    permissions {
      updateGroupAttributes
    }
    tags: appliedTags {
      id
      tagId
      type
      displayValue
      isActive
      attributes
    }
    members(limit: $membersLimit, offset: $membersOffset)
      @include(if: $includeMembers) {
      customerEmployeeId
      aggregateId
      employeeId
      firstName
      surname
      preferredName
      jobTitle
      fte
      avatar
      attributes {
        attributeType
        subtype
        value
      }
      address
      company
      isPlaceholder
      isVacancy
      tags: appliedTags {
        id
        tagId
        type
        displayValue
        isActive
      }
      allocations {
        fte
        targetGroupId
      }
      memberOf {
        id
        name
        type
        hierarchy
        hierarchyIds
        parentIds
      }
      managing {
        aggregateId
        fte
      }
      span
      managedBy {
        aggregateId
        firstName
        preferredName
        surname
        avatar
        jobTitle
      }
    }
    childTeams(limit: $teamsLimit, offset: $teamsOffset)
      @include(if: $includeTeams) {
      id
      name
      kind
      type
      directParentId
      hierarchyIds # needed for move group modal
      memberCount
      childTeamCount
      directMemberCount
      directChildTeamCount
      attributes {
        id
        attributeType
        subtype
        label
        value
      }
      tags {
        id
        type
        displayValue
        isActive
      }
      permissions {
        updateGroupAttributes
      }
    }
  }
}

query getTeamChildTeamsQuery($groupId: String!) {
  team: getGroup(groupId: $groupId) {
    id
    childTeams {
      ...TeamDetailBaseFragment
      tags {
        id
        type
        displayValue
        isActive
        attributes
        tagAttributesMetaData {
          person {
            aggregateId
            preferredName
            firstName
            surname
            avatar
          }
        }
      }
    }
  }
}

query getMemberCountForTeamsQuery($groupIds: [String]) {
  teams: getGroups(groupIds: $groupIds) {
    ...TeamMemberCountFragment
  }
}

query getTeamAssociationsQuery($groupId: String!) {
  team: getGroup(groupId: $groupId) {
    id
    groupAssociations {
      tag {
        id
        tagTypeMetadata {
          name
        }
        type
        displayValue
      }
      group {
        ...TeamDetailFragment
      }
      associationDirection {
        mode
        description
      }
    }
  }
}

query getWorksWithGroupsAndMembersQuery($groupIds: [String]) {
  getGroups(groupIds: $groupIds) {
    ...GroupBaseFragment
    members {
      ...PersonBaseFragment
      memberOf {
        id
        name
        type
        hierarchyIds
        hierarchy
        parentIds
      }
    }
  }
}

query getGroupsQuery($groupIds: [String]) {
  getGroups(groupIds: $groupIds) {
    directParentId
    directParent {
      id
      childTeams {
        ...TeamDetailBaseFragment
        directParentId
        tags {
          id
          type
          displayValue
          isActive
          attributes
          tagAttributesMetaData {
            person {
              aggregateId
              preferredName
              firstName
              surname
              avatar
            }
          }
        }
        childTeams {
          id
          type
          directParentId
        }
        members(limit: 500) {
          ...PersonCardFragment
          ...PersonManagerFragment
          address
          country
          city
          isPlaceholder
          isVacancy
        }
      }
      members(limit: 500) {
        ...PersonCardFragment
        ...PersonManagerFragment
        address
        country
        city
        isPlaceholder
        isVacancy
      }
    }
    ...GroupFragment
  }
}

query getObjectivesQuery($objectiveIds: [String]) {
  objectives: getGroups(groupIds: $objectiveIds) {
    ...ObjectiveFragment
  }
}

query listGroupsQuery($groupTypes: [String], $includeEmptyGroups: Boolean) {
  pagedGroups: listGroups(
    groupTypes: $groupTypes
    includeEmptyGroups: $includeEmptyGroups
    includeHiddenGroups: false
  ) {
    groups {
      ...TeamFragment
      childTeams {
        ...childGroupFragment
        attributes {
          id
          attributeType
          subtype
          label
          value
        }
      }
    }
  }
}

query getParentGroups($groupId: String!, $groupTypes: [String]!) {
  groups: getGroup(groupId: $groupId) {
    id
    name
    type
    descendantGroups(groupTypes: $groupTypes) {
      id
      name
      hierarchy
      type
    }
  }
}

query getDescendantGroups($groupId: String!, $groupTypes: [String]) {
  groups: getGroup(groupId: $groupId) {
    id
    name
    type
    hierarchy
    hierarchyIds
    parentIds
    directParentId
    descendantGroups(groupTypes: $groupTypes) {
      id
      name
      type
      hierarchy
      hierarchyIds
      parentIds
      directParentId
    }
  }
}

query getGroupsByTypeQuery(
  $groupTypes: [String]
  $includeEmptyGroups: Boolean
  $includeObjectives: Boolean = false
  $includeBudgets: Boolean = false
  $valueGraphQueryOptions: ValueGraphQueryOptions = {}
) {
  pagedGroups: listGroups(
    groupTypes: $groupTypes
    includeEmptyGroups: $includeEmptyGroups
    includeHiddenGroups: false
  ) {
    groups {
      ...TeamFragment
      ...TeamBudgetsFragment @include(if: $includeBudgets)
      childTeams {
        ...childGroupFragment
        ...TeamBudgetsFragment @include(if: $includeBudgets)
        permissions {
          ...GroupPermissionsFragment
        }
      }
      permissions {
        ...GroupPermissionsFragment
      }
      objectives(valueGraphQueryOptions: $valueGraphQueryOptions)
        @include(if: $includeObjectives) {
        id
        name
        kind
        type
        attributes {
          label
          value
          attributeType
        }
        datasource {
          type
        }
      }
    }
  }
}

query getGroupChildTeamsQuery(
  $groupIds: [String]
  $includeBudgets: Boolean = false
) {
  groups: getGroups(groupIds: $groupIds) {
    ...baseChildGroupFragment
    ...TeamBudgetsFragment @include(if: $includeBudgets)
    childTeams {
      ...baseChildGroupFragment
      ...TeamBudgetsFragment @include(if: $includeBudgets)
      permissions {
        ...GroupPermissionsFragment
      }
    }
    permissions {
      ...GroupPermissionsFragment
    }
  }
}

# Used for useSearchGroups hook
fragment GroupBaseFragment on Group {
  id
  name
  kind
  type
  isHidden
  parentIds
  hierarchy
  hierarchyIds
}

query getGroupBaseQuery($groupId: String!) {
  group: getGroup(groupId: $groupId) {
    ...GroupBaseFragment
  }
}

query searchGroupsQuery(
  $search: [String]
  $typeFilters: [String]
  $limit: Int
  $groupId: String!
  $isLikeGroupId: Boolean!
) {
  result: listGroups(search: $search, groupTypes: $typeFilters, limit: $limit) {
    groups {
      ...GroupBaseFragment
      attributes {
        id
        attributeType
        subtype
        label
        value
      }
      tags {
        id
        type
        displayValue
        isActive
        attributes
        tagAttributesMetaData {
          person {
            aggregateId
            preferredName
            firstName
            surname
            avatar
          }
        }
      }
    }
  }
  group: getGroup(groupId: $groupId) @include(if: $isLikeGroupId) {
    ...GroupBaseFragment
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
  }
}

query getTeamsByTagId($id: String!) {
  teams: getTeamsByTagId(id: $id) {
    ...GroupBaseFragment
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
    tags {
      id
      type
      displayValue
      isActive
      attributes
      tagAttributesMetaData {
        person {
          aggregateId
          preferredName
          firstName
          surname
          avatar
        }
      }
    }
  }
}

query getTeamsByTagIdV2(
  $id: String!
  $limit: Int
  $offset: Int
  $filter: EntitiesByTagIdFilter
  $includeAppliedCount: Boolean = false
  $tagFilter: TagFilter
) {
  result: getTeamsByTagIdV2(
    id: $id
    limit: $limit
    offset: $offset
    filter: $filter
  ) {
    totalCount
    groups {
      id
      name
      kind
      type
      hierarchyIds
      parentIds
      isHidden
      attributes {
        id
        attributeType
        subtype
        label
        value
      }
      tags: appliedTags(filter: $tagFilter) {
        ...TagsEditorEntityTagFragment
      }
    }
  }
}

query getMemberCount($groupId: String!) {
  group: getGroup(groupId: $groupId) {
    ...TeamMemberCountFragment
  }
}

query listGroupsForTeamTable(
  $limit: Int
  $offset: Int
  $includeHiddenGroups: Boolean
  $includeDeletedGroups: Boolean
  $search: [String]
  $groupTypes: [String]
) {
  result: listGroups(
    limit: $limit
    offset: $offset
    includeHiddenGroups: $includeHiddenGroups
    includeDeletedGroups: $includeDeletedGroups
    groupKinds: ["team"]
    search: $search
    groupTypes: $groupTypes
  ) {
    groups {
      id
      name
      directParentId
      hierarchyIds
      memberCount
      childTeamCount
      objectiveIds
      principles {
        met
        title
        details
      }
      attributes {
        attributeType
        subtype
        label
        value
      }
    }
    hasMore
  }
}
